//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// login-default imports
import { IProps, IState, IContainer } from "./LoginDefault.d";
import { loginDefaultFragments } from "./LoginDefault.gql";
import * as s from "./LoginDefault.styles";
// other internals
import { LoginBtn } from "@components/login-btn";
import { MsftLoginButton } from "@components/msft-login-button";
import { CookieDialog } from "@clockwise/web-commons/src/components/cookie-dialog";
import { H2, P, A } from "@ui";
// img
import { logoClockWhite } from "@img/logos";
// util
import { PostMessageManager } from "@util/post-message.util";
import { page, PageEvents, track, TrackingEvents } from "@util/analytics.util";
// constants
import { paths } from "@constants/site.constant";
// state
import { IReduxState } from "@reducers/root.reducer";
import { hasSeenLoginPage, cwM365 } from "@state/local-storage";
import { loginUser } from "@mutations";
import { snackBarOpen } from "@actions/snack-bar.actions";
// material-ui
import { LinearProgress } from "@material-ui/core";

//////////////////
// COMPONENT
//////////////////
class LoginDefaultCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      loading: false,
      hideCookieErrorDialog: true,
    };
    this.onLoginStart = this.onLoginStart.bind(this);
    this.onLoginSuccess = this.onLoginSuccess.bind(this);
    this.onLoginFailure = this.onLoginFailure.bind(this);
  }

  public componentDidMount() {
    page(PageEvents.LOGIN);
    hasSeenLoginPage.set(true);
    if (this.props.isChromeExtension) {
      PostMessageManager.openSidebar(true);
    }
  }

  private onLoginStart = () => {
    track(TrackingEvents.AUTH.BEGIN_LOGIN);
    this.setState({ loading: true });
  };

  private onLoginSuccess = () => {
    // nop
  };

  private onLoginFailure = (_e: any) => {
    track(TrackingEvents.AUTH.LOGIN_FAILED);
    this.setState({ loading: false });
  };

  private onGoogleFailure = (e: any) => {
    if (e.error === "idpiframe_initialization_failed") {
      this.setState({
        hideCookieErrorDialog: false,
      });
    }
  };

  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    // detect login success and redirect using current org experiments
    if (nextProps.viewer.user && !this.props.viewer.user) {
      this.setState({ loading: false });
      this.forceUpdate();
    }
  }

  private renderCookieDialog() {
    return (
      <CookieDialog
        isChromeExtension={this.props.isChromeExtension}
        open={!this.state.hideCookieErrorDialog}
      />
    );
  }

  public render() {
    return (
      <React.Fragment>
        {this.renderCookieDialog()}
        <div style={s.container}>
          <div style={s.paper}>
            <div style={s.content.hero}>
              <img src={logoClockWhite} style={s.content.logo} />
            </div>
            <div style={s.content.body}>
              <H2 style={s.content.header}>Sign in to Clockwise with your work calendar</H2>
              <div style={s.content.button}>
                <LoginBtn
                  label="Sign in with Google"
                  googleStandard
                  loginUserMutation={loginUser}
                  style={s.signupBtn.base}
                  labelStyle={s.signupBtn.label}
                  redirect={this.props.redirect}
                  onStart={this.onLoginStart}
                  onSuccess={this.onLoginSuccess}
                  onFailure={this.onLoginFailure}
                  onGoogleFailure={this.onGoogleFailure}
                />
                {cwM365.get() ? (
                  <>
                    <div style={{ marginTop: 10 }} />
                    <MsftLoginButton redirect={this.props.redirect} />
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            {this.state.loading ? (
              <LinearProgress style={s.loadingBar} variant="indeterminate" />
            ) : (
              ""
            )}
            <P style={s.content.agreement}>
              By signing in, you agree to Clockwise's{" "}
              <A style={s.content.link} target="_blank" href={paths.terms}>
                Terms of Service
              </A>{" "}
              and{" "}
              <A style={s.content.link} target="_blank" href={paths.privacy}>
                Privacy Policy
              </A>
              .
            </P>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

const reduxContainer = connect(mapStateToProps, {
  snackBarOpen,
})(LoginDefaultCmpt);

//////////////////
// RELAY
//////////////////
export const LoginDefault = createFragmentContainer<IContainer>(
  reduxContainer,
  loginDefaultFragments,
);
